import React, {Component} from 'react';
import {connect} from 'react-redux';
import moment from 'moment';
import {Card, Button, Icon} from 'semantic-ui-react';
import {resources, scopes} from '../../../common/permissions/dictionary';
import {hasAccessPermission} from '../../../common/permissions/validations';
import {paths} from '../../../common/dictionaries/urls';
import {pageSizes} from '../../../common/constants/lists';
import {dateFormatShow} from '../../../common/constants/datesFormat';
import {priorities} from '../../../common/dictionaries/forms';
import {handleExcelReport} from '../../../common/components/commercialTable/exportUtils/handleExport';
import {Actions} from '../../../common/actions';
import SearchFTRResults from './Results';
import SearchFTRFilters from './Filters';
import './search.scss';

const EXPORT_TITLES = [
  {'title': 'DTR No.', 'accessor': 'formNumber'},
  {'title': 'Tipo', 'accessor': 'type'},
  {'title': 'Título DTR', 'accessor': 'title'},
  {'title': 'Prioridad', 'accessor': 'priority'},
  {'title': 'Usuario', 'accessor': 'user'},
  {'title': 'Concesionario', 'accessor': 'dealerName'},
  {'title': 'Agencia', 'accessor': 'agencyName'},
  {'title': 'Chasis / VIN', 'accessor': 'chassis'},
  {'title': 'Modelo', 'accessor': 'modelName'},
  {'title': 'Katashiki', 'accessor': 'katashiki'},
  {'title': 'Año', 'accessor': 'year'},
  {'title': 'Año Modelo', 'accessor': 'modelYear'},
  {'title': 'País de Origen', 'accessor': 'country'},
  {'title': 'Fecha de Venta', 'accessor': 'saleOfDate'},
  {'title': 'Kilometraje', 'accessor': 'mileage'},
  {'title': 'Unidad', 'accessor': 'mileageMeasurement'},
  {'title': 'Reparado', 'accessor': 'isRepared'},
  {'title': 'Fecha de Reparación', 'accessor': 'repairOfDate'},
  {'title': 'Fecha de Publicación', 'accessor': 'createdDate'},
  {'title': 'O.F.P.', 'accessor': 'ofp'},
  {'title': 'Parte de Corrección', 'accessor': 'correctionPart'},
];

const formatDate = (value) => (value ? moment(value).format(dateFormatShow) : '');

const formatRepared = (value) => {
  if (value === 'YES' || value === 'SI' || value === 'SÍ' || value === true) {
    return 'Sí';
  }
  if (value === 'NO' || value === false) {
    return 'No';
  }
  return '';
};

const mileageUnit = (value) => {
  if (value === 'KILOMETERS' || value === 'KM') {
    return 'Km';
  }
  if (value === 'MILLAS' || value === 'MILES') {
    return 'Millas';
  }
  return value || '';
};

const buildExportRow = (element, vehicleMap) => {
  const generalInfo = element.generalInfo || {};
  const answers = element.answers || {};
  const priorityCode = generalInfo.priority;
  const chassis = (generalInfo.chassis || '').toUpperCase();
  const vehicle = vehicleMap[chassis] || {};

  return {
    'formNumber': element.formNumber || '',
    'type': element.type || '',
    'title': answers.title || '',
    'priority': priorities[priorityCode] || priorityCode || '',
    'user': generalInfo.user || '',
    'dealerName': generalInfo.dealerName || '',
    'agencyName': generalInfo.agencyName || '',
    'chassis': chassis,
    'modelName': generalInfo.modelName || '',
    'katashiki': vehicle.katashiki || '',
    'year': generalInfo.year || '',
    'modelYear': vehicle.modelYear || '',
    'country': vehicle.country || '',
    'saleOfDate': formatDate(generalInfo.saleOfDate),
    'mileage': generalInfo.mileage || '',
    'mileageMeasurement': mileageUnit(generalInfo.mileageMeasurement),
    'isRepared': formatRepared(generalInfo.isRepared),
    'repairOfDate': formatDate(generalInfo.repairOfDate),
    'createdDate': formatDate(element.createdDate),
    'ofp': generalInfo.ofp || '',
    'correctionPart': generalInfo.correctPart || '',
  };
};

class SearchFTR extends Component {
  constructor(props) {
    super(props);
    this.state = {
      'showFiltersSection': true,
      'limitQuery': 20,
      'dealerFilter': '',
      'sectionFilter': '',
      'formTypeFilter': '',
      'formNumberFilter': '',
      'ofpFilter': '',
      'modelFilter': '',
      'causeFilter': '',
      'startDateFilter': '',
      'endDateFilter': '',
      'typeService': '',
      'exporting': false,
    };
    this.onCancelClick = this.onCancelClick.bind(this);
    this.onSearchClick = this.onSearchClick.bind(this);
    this.onNewClick = this.onNewClick.bind(this);
    this.onExportClick = this.onExportClick.bind(this);
    this.updateSearchFilters = this.updateSearchFilters.bind(this);
  }

  componentDidMount() {
    if (!hasAccessPermission(this.props.permissions, resources.FormsSearch, scopes.See)) {
      this.props.navigateTo(paths.AccessDenied);
    }
    this.props.changeSearchFtrListPageSize(pageSizes[1].value);
    this.onSearchData(20);
  }

  getFilters(limitQuery) {
    const {
      dealerFilter,
      sectionFilter,
      formTypeFilter,
      formNumberFilter,
      ofpFilter,
      modelFilter,
      causeFilter,
      startDateFilter,
      endDateFilter,
      typeService,
    } = this.state;

    const filters = {
      'formsTypes': 'FTR,RSR',
      'limit': limitQuery,
      'formNumber': formNumberFilter,
      'section': sectionFilter,
      'ofp': ofpFilter,
      'model': modelFilter,
      'cause': causeFilter,
      'startDate': startDateFilter,
      'endDate': endDateFilter,
      'typeService': typeService,
    };

    if (dealerFilter && dealerFilter !== 'ALL') {
      filters.dealerId = dealerFilter;
    }

    if (formTypeFilter) {
      filters.formType = formTypeFilter;
      filters.formsTypes = '';
    }

    Object.keys(filters).forEach((key) => {
      if (!filters[key]) {
        delete filters[key];
      }
    });

    return filters;
  }

  onSearchClick(limitQuery = null) {
    this.setState({'showFiltersSection': false}, () =>
      this.onSearchData(limitQuery)
    );
  }

  onSearchData(limitQuery) {
    this.props.changeSearchFtrListPage(0);
    const filters = this.getFilters(limitQuery);
    this.props.fetchPublishedAnswersList(filters);
  }

  onNewClick() {
    this.props.navigateTo(paths.FormsList);
  }

  async onExportClick() {
    const {answersFullList} = this.props;
    this.setState({'exporting': true});

    try {
      const chassisList = [...new Set(
        answersFullList
          .map((el) => (el.generalInfo && el.generalInfo.chassis ? el.generalInfo.chassis : null))
          .filter(Boolean)
      )];

      let vehicleMap = {};
      if (chassisList.length) {
        const vehiclesData = await this.props.fetchVehiclesBatch(chassisList);
        (vehiclesData || []).forEach((v) => {
          if (v && v.chassis) {
            vehicleMap[v.chassis] = {
              'modelYear': v.modelYear,
              'country': v.country,
              'katashiki': v.katashiki,
            };
          }
        });
      }

      const rows = answersFullList.map((el) => buildExportRow(el, vehicleMap));
      handleExcelReport(rows, EXPORT_TITLES, null, 'REPORTE-DTR-RSR');
    } finally {
      this.setState({'exporting': false});
    }
  }

  onShowFiltersSectionClick(show) {
    this.setState({'showFiltersSection': show});
  }

  onCancelClick() {
    this.setState(
      {
        'dealerFilter': '',
        'sectionFilter': '',
        'formTypeFilter': '',
        'formNumberFilter': '',
        'ofpFilter': '',
        'modelFilter': '',
        'causeFilter': '',
        'startDateFilter': '',
        'endDateFilter': '',
        'typeService': '',
      },
      () => {
        this.onSearchClick(20);
      }
    );
  }

  disableCancelButton() {
    const {loading} = this.props;
    const {
      dealerFilter,
      sectionFilter,
      formTypeFilter,
      formNumberFilter,
      ofpFilter,
      modelFilter,
      causeFilter,
      startDateFilter,
      typeService,
    } = this.state;
    const emptyAllFilters =
      !dealerFilter &&
      !sectionFilter &&
      !formTypeFilter &&
      !formNumberFilter &&
      !ofpFilter &&
      !modelFilter &&
      !causeFilter &&
      !startDateFilter &&
      !typeService;

    return loading || emptyAllFilters;
  }

  disableSearchButton() {
    const {loading} = this.props;
    const {
      dealerFilter,
      sectionFilter,
      formTypeFilter,
      formNumberFilter,
      ofpFilter,
      modelFilter,
      causeFilter,
      startDateFilter,
      typeService,
    } = this.state;
    const requiredFilters =
      dealerFilter ||
      sectionFilter ||
      formTypeFilter ||
      formNumberFilter ||
      ofpFilter ||
      modelFilter ||
      causeFilter ||
      startDateFilter ||
      typeService;

    return loading || !requiredFilters;
  }

  disableExportButton() {
    const {loading, answersFullList} = this.props;
    const {exporting} = this.state;
    return loading || exporting || !answersFullList.length;
  }

  updateSearchFilters(value, filterName) {
    this.setState({[filterName]: value});
  }

  renderShowOrHideFilter() {
    const {showFiltersSection} = this.state;
    if (!showFiltersSection) {
      return (
        <Icon
          name='angle right'
          onClick={() => this.onShowFiltersSectionClick(true)}
        />
      );
    }
    return (
      <Icon
        name='angle down'
        onClick={() => this.onShowFiltersSectionClick(false)}
      />
    );
  }

  render() {
    const {
      showFiltersSection,
      dealerFilter,
      sectionFilter,
      formTypeFilter,
      formNumberFilter,
      ofpFilter,
      modelFilter,
      causeFilter,
      startDateFilter,
      endDateFilter,
      typeService,
      exporting,
    } = this.state;
    const {loading} = this.props;
    return (
      <div className='ftr-search-page'>
        <Card raised fluid>
          <div className='title-bar'>
            <div className='title'>
              <h2>Consulta de FTR / RSR</h2>
              {this.renderShowOrHideFilter()}
              <div className='title-bar-actions'>
                <Button
                  type='button'
                  secondary
                  className='toyota-secondary'
                  disabled={this.disableCancelButton()}
                  onClick={this.onCancelClick}
                >
                  Limpiar
                </Button>
                <Button
                  primary
                  type='submit'
                  className='toyota-primary'
                  disabled={this.disableSearchButton()}
                  onClick={() => this.onSearchClick(null)}
                >
                  Buscar
                </Button>
                <Button
                  type='button'
                  className='export-excel-btn'
                  loading={exporting}
                  disabled={this.disableExportButton()}
                  onClick={this.onExportClick}
                >
                  <img
                    src={`${process.env.PUBLIC_URL}/media/excel-icon.jpg`}
                    alt='Excel'
                    className='export-excel-btn__icon'
                  />
                  <span className='export-excel-btn__label'>Exportar a Excel</span>
                </Button>
                <Button
                  primary
                  type='submit'
                  className='toyota-primary'
                  disabled={loading}
                  onClick={this.onNewClick}
                >
                  Nuevo
                </Button>
              </div>
            </div>

            <SearchFTRFilters
              showFiltersSection={showFiltersSection}
              dealerFilter={dealerFilter}
              sectionFilter={sectionFilter}
              formTypeFilter={formTypeFilter}
              formNumberFilter={formNumberFilter}
              ofpFilter={ofpFilter}
              modelFilter={modelFilter}
              causeFilter={causeFilter}
              startDateFilter={startDateFilter}
              endDateFilter={endDateFilter}
              typeService={typeService}
              updateSearchFilters={this.updateSearchFilters}
            />
          </div>
        </Card>
        <SearchFTRResults />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'loading': state.searchFTR.loading,
    'answersFullList': state.searchFTR.list,
    'dealerId': state.session.dealerId,
    'permissions': state.session.permissions,
  };
};

const {
  navigateTo,
  fetchPublishedAnswersList,
  changeSearchFtrListPage,
  changeSearchFtrListPageSize,
  fetchVehiclesBatch,
} = Actions;

export default connect(mapStateToProps, {
  navigateTo,
  fetchPublishedAnswersList,
  changeSearchFtrListPage,
  changeSearchFtrListPageSize,
  fetchVehiclesBatch,
})(SearchFTR);
